import type { IsoDate, IsoMonth } from '../types/primitives';

/**
 * "September" — a month's NAME in a locale, for the headings a month is (the spend screen's tile, the period chip's
 * "This month" words). Not a REQ-261 context: D-132 / D-166 ruled that a month heading carries no precision decision,
 * so there is no `date.month` row and never will be — but the slice-0.4 review's R-3 found three app files asking
 * `Intl` for the same thing with the same workaround comment, and ONE helper is how they stop (T-338, D-1229).
 *
 * Built in UTC on purpose: `YYYY-MM` carries no zone, and the first of a month is the first of a month everywhere, so
 * the instant `Date.UTC(y, m — 1, 1)` formatted with `timeZone: 'UTC'` can never slip across a zone boundary — the
 * same trick `format` uses for a calendar date. Garbage in is an empty string out, never a throw (REQ-287 AC3).
 */
export function monthName(month: IsoMonth | IsoDate, locale: string): string {
  const date = new Date(`${month.slice(0, 7)}-01T00:00:00Z`);
  if (Number.isNaN(date.getTime())) return '';
  return new Intl.DateTimeFormat(locale, { month: 'long', timeZone: 'UTC' }).format(date);
}
